const locale = {
	DETAILS_WEBSITES_FIELD_TITLE: 'URL',
	DETAILS_WEBSITES_FIELD_DESCRIPTION: 'Descrizione'
};

export default locale;
